export default {
    baseStyle: {
        countryContainer: {
            position: 'relative'
        },
        countries: {
            width: '92px',
            mr: '-1px',
            _focus: {
                zIndex: 1,
                borderColor: 'fullBlack',
                boxShadow: 'outline'
            },
            _invalid: {
                borderColor: 'red',
                _focus: {
                    borderColor: 'red'
                }
            }
        },
        countrySelected: {
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            left: '20px',
            zIndex: 2,
            pointerEvents: 'none'
        },
        label: {
            left: '92px !important',
            transform: 'scale(0.9) translateY(-29px)',
            backgroundColor: 'white'
        },
        dial: {
            fontSize: '2xl',
            margin: '0 0 0 20px',
            width: '50px',
            justifyContent: 'flex-start'
        },
        phone: {
            pl: '70px'
        }
    },
    parts: ['container', 'countries', 'label']
}
